import {DistrictModelV1} from 'resources/GeneratedModels/District/DistrictModel.v1';

import {districtModelValidators} from './DistrictModel.v1.validators';

DistrictModelV1.addValidators(districtModelValidators);

export {DistrictModelV1};
